import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=2ef39741&scoped=true"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=2ef39741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef39741",
  null
  
)

export default component.exports